import * as React from 'react';
import { compKey } from './key';
import { useState } from 'react';
import { FloaterMenu, MenuItem, MenuItemDivider } from '../../composites/floater-menu/floater-menu';
import { classNames } from '@wix/answers-lib';
import { icon as UpperArrowIcon } from '../../icons/processed/upper-arrow-right.svg';
import { namespacedClassnames } from '../../common';
import { Text } from '../../new-libby';
import { Column, Icon, Row } from '../../primitives';
export var ItemsMenuWithImage = function (_a) {
    var options = _a.options, onSelect = _a.onSelect;
    var _b = useState(options[0]), hoveredItem = _b[0], setHoveredItem = _b[1];
    var shouldShowLinkIcon = function (option) { return !option.disabled && option.isLink; };
    var renderMenuItems = React.createElement("div", { className: 'menu-items' },
        React.createElement(FloaterMenu, null, options.map(function (option, index) { return (React.createElement("div", { key: option.id, className: classNames('menu-item-single', "title-" + option.id), onMouseOver: function () { return setHoveredItem(options[index]); } },
            React.createElement(MenuItem, { className: "menu-item-" + option.id, disabled: option.disabled, onSelect: function () { return onSelect(option); } },
                React.createElement(Row, null,
                    option.title,
                    shouldShowLinkIcon(option) && React.createElement(Icon, { icon: UpperArrowIcon }))),
            option.dividerOnBottom && React.createElement(MenuItemDivider, { className: "divider-" + option.id }))); })));
    var renderMenuSideBar = React.createElement(Column, { className: "side-bar", textAlign: 'center', gap: '4', padding: '16', verticalAlignment: 'center', horizontalAlignment: 'center' },
        React.createElement(Icon, { className: 'side-bar-icon', icon: hoveredItem.icon }),
        React.createElement(Text, { className: 'side-bar-title', type: 'hxsm', color: 't20' }, hoveredItem.title),
        React.createElement(Text, { className: 'side-bar-description', type: 'ht', color: 't30' }, hoveredItem.description));
    return (React.createElement("div", { className: namespacedClassnames(compKey) },
        renderMenuItems,
        renderMenuSideBar));
};
//# sourceMappingURL=index.js.map